import config from "../../config/domain";
import React, { useEffect, useState } from "react";
import { Alert, Toast, ToastContainer } from "react-bootstrap";
import Errormsg from "./errorMsg";
import ConfirmationPopup from "./ConfirmationPopup/ConfirmationPopup";
import { ThirdPartyCallBack, EMTReportCallBack, } from "@domains/utils/emtReportCallback";
import { useSelector } from "react-redux";
import DeviceContext from "../../utils/indentifyDevice";
import Drawer from "react-bottom-drawer";
import EdButton from "./edbutton/edButton";
export var ErrorDisplayType;
(function (ErrorDisplayType) {
    ErrorDisplayType["ALERT"] = "alert";
    ErrorDisplayType["POPUP"] = "popup";
    ErrorDisplayType["TOAST"] = "toast";
    ErrorDisplayType["INSECTION"] = "inSection";
    ErrorDisplayType["NONE"] = "none";
})(ErrorDisplayType || (ErrorDisplayType = {}));
const ErrorNotification = (props) => {
    // const isOpen = useSelector((state: RootState) => state.errorReducer.isOpen);
    // const error = useSelector((state: RootState) => state.errorReducer.error);
    var _a, _b, _c, _d, _e, _f;
    // const dispatch = useDispatch();
    const [displayType, setDisplayType] = useState(props.displayType);
    const [modalTitle, setModalTitle] = useState("");
    const [popupUI, setPopupUI] = useState(null);
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    function handleClose() {
        props.onClose();
    }
    const redirect = () => {
        localStorage.setItem("revampSessionExpired", "true");
        localStorage.setItem("redirectUrl", window.location.toString());
        EMTReportCallBack(AccountDetails.lgnSrc, ThirdPartyCallBack.SessionExpire);
        window.location.href = config.oldWebUrl;
    };
    const unAuthorizeError = () => {
        return (React.createElement("div", null,
            React.createElement("p", null, "Your Session is Expired. Please login again."),
            React.createElement(EdButton, { type: "button", className: "login-btn", onClick: redirect, value: "Login", btnTyp: "blue-one" })));
    };
    useEffect(() => {
        var _a;
        if (props.error && props.isOpen) {
            switch ((_a = props.error) === null || _a === void 0 ? void 0 : _a.getHttpCode()) {
                case 401:
                case 403:
                    setModalTitle("Session Expired!");
                    setPopupUI(unAuthorizeError());
                    setDisplayType(ErrorDisplayType.POPUP);
            }
        }
    }, []);
    switch (displayType) {
        case ErrorDisplayType.ALERT:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(Alert
            // show={isOpen}
            , { 
                // show={isOpen}
                key: "danger", variant: "danger", onClose: handleClose, dismissible: true, style: { display: props.isOpen ? "block" : "none" } },
                React.createElement(Alert.Heading, null, "Oh snap! You got an error!"),
                React.createElement("span", null, (_a = props.error) === null || _a === void 0 ? void 0 : _a.getErrorMessege())))));
        case ErrorDisplayType.POPUP:
            return (React.createElement(React.Fragment, null, props.isOpen && props.error && (React.createElement("div", { id: "error" }, DeviceContext().isDesktop ? (React.createElement(ConfirmationPopup, { show: true, popTitle: modalTitle, showFooter: false, popupClass: "withShadow" }, popupUI)) : (React.createElement(Drawer, { duration: 250, hideScrollbars: true, className: "error_wrapper", isVisible: true, onClose: () => { } }, popupUI))))));
        case ErrorDisplayType.TOAST:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(ToastContainer, { className: "p-3", position: "top-end", style: { zIndex: "9999" } },
                React.createElement(Toast, { onClose: handleClose, bg: "danger", style: { display: props.isOpen ? "block" : "none" } },
                    React.createElement(Toast.Header, null,
                        React.createElement("img", { src: "", className: "rounded me-2", alt: "" }),
                        React.createElement("strong", { className: "me-auto" }, props.headerTitle ? props.headerTitle : "Error"),
                        React.createElement("small", null, "1 mins ago")),
                    React.createElement(Toast.Body, null, (_b = props.error) === null || _b === void 0 ? void 0 : _b.getErrorMessege()))))));
        case ErrorDisplayType.INSECTION:
            return (React.createElement(React.Fragment, null, props.isOpen && props.error && (React.createElement("div", { id: "error" },
                React.createElement(Errormsg, { msg: ((_c = props.error) === null || _c === void 0 ? void 0 : _c.getHttpCode()) === 400 ||
                        ((_d = props.error) === null || _d === void 0 ? void 0 : _d.getHttpCode()) === 500 ||
                        ((_e = props.error) === null || _e === void 0 ? void 0 : _e.getHttpCode()) === 222
                        ? (props === null || props === void 0 ? void 0 : props.showDirectMessage)
                            ? "Something went wrong! Please try again later"
                            : (_f = props.error) === null || _f === void 0 ? void 0 : _f.getErrorMessageOrErrMsg()
                        : "Oops! Looks like one of those days, we have run <br/> into some technical difficulties. Please refresh", refresh: props.refresh ? true : false, refreshFunc: props.refresh })))));
        case ErrorDisplayType.NONE:
            return React.createElement(React.Fragment, null);
        default:
            return (React.createElement("div", { id: "error" }, props.error && (React.createElement(Alert
            // show={isOpen}
            , { 
                // show={isOpen}
                key: "danger", variant: "danger", onClose: handleClose, dismissible: true, style: { display: props.isOpen ? "block" : "none" } },
                React.createElement(Alert.Heading, null, "Oh snap! You got an error!"),
                React.createElement("span", null, props.error.getErrorMessege())))));
    }
};
export default ErrorNotification;
